<template>
  <div>
    <v-container grid-list-lg>
      <!-- <wz-select-one-agent disabled></wz-select-one-agent> -->
    </v-container>
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else-if="!loading">
      <!-- Import des phrases d'un autre agent -->
      <v-btn
        v-if="$store.state._Biblios.biblios.length"
        flat
        @click="openDialogImport()"
        color="primary"
        :block="$vuetify.breakpoint.smAndDown"
      >
        {{ $t('importSentencesFromAgent') }}
        <v-icon right>get_app</v-icon>
      </v-btn>
      <v-card class="mb-5">
        <!-- Au moins un résultat -->
        <v-list two-line dense>
          <v-subheader v-if="$store.state._Biblios.biblios.length">
            {{ $tc('libraries', $store.state._Biblios.biblios.length, { count: $store.state._Biblios.biblios.length }) }}
          </v-subheader>
          <template v-for="(biblio, i) in $store.state._Biblios.biblios">
            <wz-biblio :biblio="biblio" :key="i"></wz-biblio>
          </template>
        </v-list>
        <!-- Aucun résultat -->
        <v-container fluid grid-list-lg v-if="!$store.state._Biblios.biblios.length">
          <v-layout row>
            <v-flex xs3>
              <v-img
                src="https://www.gstatic.com/mobilesdk/160505_mobilesdk/zerostate/2x/database.png"
                height="125px"
                contain
              ></v-img>
            </v-flex>
            <v-flex xs7>
              <div>
                <div class="headline">{{ $tc('libraries', 0, {count: '' }) | cap }}</div>
                <div v-html="$t('sentencesMustInLibrary')"></div>
                <v-btn
                  flat
                  @click="openDialogImport()"
                  color="primary"
                  :block="$vuetify.breakpoint.smAndDown"
                >
                  {{ $t('importSentencesFromAgent') }}
                  <v-icon right>get_app</v-icon>
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </div>
    <!-- BOUTON FLOTTANT AJOUT -->
    <v-fab-transition>
      <v-tooltip left>
        <v-btn
          fab
          bottom
          floating
          fixed
          raised
          right
          dark
          color="secondary"
          class="white--text"
          slot="activator"
          @click.stop="openDialogCreate"
          v-show="!loading"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>{{ $t('add') | cap }} {{ $tc('libraries', 1) }}</span>
      </v-tooltip>
    </v-fab-transition>

    <!-- DIALOGUE -->
    <v-dialog v-model="showDialogCreate" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('add') | cap }} {{ $tc('libraries', 1) }}</v-card-title>
        <v-card-text>
          <v-text-field
            autofocus
            :label="$t('title')" 
            v-model="biblioDialog.title"
            counter 
            max="32" 
            required
            v-validate="'required|max:32'" 
            data-vv-name="title"
            :error="wzErrors.has($t('title'))"
            :error-messages="wzErrors.collect($t('title'))"
            @keyup.enter="submitDialogCreate" 
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="showDialogCreate = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" :disabled="wzErrors.any()" @click="submitDialogCreate">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialogue d'import de biblios -->
    <v-dialog v-model="dialogImport" persistent max-width="350">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('importSentencesFromAgent') }}</v-card-title>
        <v-card-text>
          <wz-select-one-agent :agent.sync="agent" withoutMe></wz-select-one-agent>
          <div v-html="$t('infosImportSentencesFromAgent')"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            :loading="loadingImport"
            @click="dialogImport = false"
          >{{ $t('cancel') }}</v-btn>
          <v-btn
            v-if="agent"
            color="primary"
            :loading="loadingImport"
            @click="submitDialogImport"
          >{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data: () => ({
    /**
     * indique si une requête ajax en cours
     * @type {Boolean}
     */
    loading: false,
    /**
     * affiche/cache la fenetre de dialog de création
     * @type {Boolean}
     */
    showDialogCreate: false,
    /**
     * nouvelle bibliothèque à créer
     * @type {Object}
     */
    biblioDialog: {},
    /**
     * Indique si la dialog pour l'import des phrases d'un autre agent est ouverte
     */
    dialogImport: false,
    loadingImport: false,
    /**
     * Agent choisi pour importer les phrases
     */
    agent: null,
    dialogProgress: false
  }),

  /**
   * à la création de la vue, requête afin de récupérer les biblios de phrases de l'utilisateur
   */
  created () {
    this.getBiblios()
    this.biblioDialog = this.newBiblio()
    // moi étant agent par défaut
    this.agent = this.$store.state._User.colleagues.find(
      a => a.USR_ID === this.$store.state._User.id
    )
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'media_biblios'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'media_biblios'
        }
      }, 800);
    }
    /* eslint-enable */
  },
  mounted () {
    // if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
    //   this.openDialogProgress()
    // }
  },
  methods: {
    getBiblios () {
      this.loading = true
      this.$store.dispatch('_Biblios/GET', this.$store.state._User.id).then(() => {
        this.loading = false
      })
    },
    /**
     * ouvre la fenêtre de dialogue et initialise une nouvelle bibliothèque à créer
     */
    openDialogCreate () {
      this.biblioDialog = this.newBiblio()
      this.showDialogCreate = true
    },
    /**
     * valide la nouvelle bibliothèque à créer
     */
    submitDialogCreate () {
      this.showDialogCreate = false
      if (_.isEmpty(this.biblioDialog.title)) {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('creationFailure') + ' ' + this.$t('empty'),
          context: 'warning'
        })
        return
      }
      // recherche de la biblio dans la liste des biblios
      // si elle n'est pas trouvée alors on peut la créer
      let biblioFound = this.$store.getters['_Biblios/GET_BIBLIO_BY_TITLE'](
        this.biblioDialog.title
      )
      if (_.isNil(biblioFound)) {
        // création côté serveur en BDD
        let dataToPost = new window.FormData()
        dataToPost.append('FAM_NAME', this.biblioDialog.title)
        dataToPost.append('ENT_ID', this.$store.state._User.entId)

        // onboarding
        let steps = JSON.parse(this.$store.state._User.remainingSteps)
        // si cette étape est encore dans le tableau
        if (steps && typeof steps !== 'undefined' && steps && typeof steps !== 'undefined' && steps.indexOf('INS_MEDIA_BIBLIOS')) {
          // on l'efface du tableau
          steps.splice(steps.indexOf('INS_MEDIA_BIBLIOS'), 1)
          // mise à jour du store _User
          this.$store.commit('_User/MAJ_PROGRESSION', {
            remainingSteps: JSON.stringify(steps)
          })
        }
        // steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1)
        // this.$store.state._User.remainingSteps = JSON.stringify(steps)
        // this.$store.state._User.installProgress += 10

        this.axios
          .post('post/biblio.php', dataToPost, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(response => {
            // les changements été pris en compte :
            // - attribution d'un id pour la biblio qui vient d'être créée
            this.biblioDialog.id = response.data.id
            this.biblioDialog.title = this.biblioDialog.title
            this.$store.commit('_Biblios/ADD_BIBLIO', this.biblioDialog)
            // Notification
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: this.$t('creationSuccess'),
              context: 'success'
            })
          })
          .catch(_ => {
            // Notification
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: this.$t('creationFailure'),
              context: 'error'
            })
          })
          .then(_ => {
            this.loading = false
          })
      } else {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('alreadyExists'),
          context: 'warning'
        })
      }
    },
    /**
     * initialise la bibliothèque gérée par le composant
     */
    newBiblio () {
      return {
        id: '',
        title: '',
        sentences: [],
        subs: []
      }
    },
    /**
     * Ouvre la dialog d'import de phrases
     */
    openDialogImport () {
      this.dialogImport = true
    },
    submitDialogImport () {
      let params = new window.FormData()
      params.append('src', this.agent.USR_ID)
      params.append('dest', this.$store.state._User.id)
      this.loadingImport = true
      this.axios.post('post/import_sentences.php', params, {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
      .then(res => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('importSuccess'),
          context: 'success'
        })
        this.getBiblios()
      })
      .catch(() => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('importFailure'),
          context: 'error'
        })
      })
      .then(() => {
        this.loadingImport = false
        this.dialogImport = false
      })
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/Biblios.vue